import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap'
import forceLogout from '../helpers/forceLogout'
import TwoStepConfirmationButton from '../components/TwoStepConfirmButton';
import ActionResult from '../components/ActionResult';
import tableHelpers from '../helpers/TableHelpers.js'

function ManagePlans(props) {
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [updates, setUpdates] = useState(0);
    const [cloneTrades, setCloneTrades] = useState(false);
    const [result, setResult] = useState(null);

    useEffect(() => {
        (async function () {
            setData([]);
            setOriginalData([]);
            console.log("Loading plans...");

            const response = await fetch(`/api/subscriptions?userId=` + props.userId)
            if (!response.ok) {
                console.error(`Failed to load subscriptions for user ${props.userId} - HTTP ${response.status}`)
                forceLogout()
                return
            }

            const text = await response.json();
            setData(text);
            setOriginalData(text);
        })();
    }, [updates, props.userId]);

    function onDescriptionUpdated(planId, description) {
        const newData = data.map((plan) => {
            if (plan.idplans === planId) {
                return { ...plan, description: description };
            }
            return plan;
        });

        setData(newData);
    }

    function onNameUpdated(planId, name) {
        const newData = data.map((plan) => {
            if (plan.idplans === planId) {
                return { ...plan, name: name };
            }
            return plan;
        });
        setData(newData);
    }

    async function handleSubmitDescription(planId) {
        console.log("handleSubmitDescription", planId);
        let plan = data.find(p => p.idplans === planId);
        if (plan) {
            const url = "/api/planUpdate?planId=" + planId + "&name=" + plan.name + "&description=" + plan.description;
            await (await fetch(url)).json();
            setUpdates(updates + 1)
            if (props.onPlansUpdated)
                props.onPlansUpdated();
        } else {
            console.log("Could not find plan to update", planId);
        }
    }
    async function handleClone(planId) {
        console.log("handleClone", planId, props.onPlansUpdated);
        const url = `/api/clonePlan?planId=` + planId + `&userId=` + props.userId + "&cloneTrades=" + (cloneTrades ? "1" : "0");
        await fetch(url);
        setUpdates(updates + 1)
        if (props.onPlansUpdated)
            props.onPlansUpdated();
    }

    async function handleDelete(planId) {
        console.log("handleDelete", planId);
        const url = `/api/planDelete?planId=` + planId + `&userId=` + props.userId;
        let result = await (await fetch(url)).json();
        setResult(result);
        setUpdates(updates + 1)
        if (props.onPlansUpdated)
            props.onPlansUpdated();
    }

    async function handleRestoreAllocations(planId) {
        console.log("handleRestoreAllocations", planId);
        setResult(null);
        const url = `/api/copyAllocationsFromOriginal?planId=` + planId + `&userId=` + props.userId;
        let result = await (await fetch(url, { method: 'POST' })).json();
        setResult(result);
        setUpdates(updates + 1)
        if (props.onPlansUpdated)
            props.onPlansUpdated();
    }

    function shouldAllowEdits(planId) {
        if (props.role === 3) return true;
        let plan = data.find(p => p.idplans === planId);
        if (plan && props.userId === plan.userIdOwner) return true;
        return false;
    }

    async function handleUpdateHedgeStrategy(planId, shouldMerge) {
        console.log("handleUpdateHedgeStrategy", planId);
        if (shouldAllowEdits(planId)) {
            const url = `/api/planHedgeUpdate?planId=` + planId + `&merge=` + shouldMerge;
            let result = await (await fetch(url, { method: 'post' })).json();
            setResult(result);
            setUpdates(updates + 1)
            if (props.onPlansUpdated)
                props.onPlansUpdated();
        } else {
            setResult({ error: "Not allowed" })
        }
    }

    async function handleCircuitBreakerTrigger(planId) {
        console.log("handleCircuitBreakerTrigger", planId);
        let plan = data.find(p => p.idplans === planId);
        if (plan) {
            const url = `/api/planCircuitBreakerTriggered?planId=` + planId + `&disabled=` + (plan.trading_disabled ? "false" : "true");
            let result = await fetch(url, { method: 'POST' });
            setResult(result);
            setUpdates(updates + 1)
            if (props.onPlansUpdated)
                props.onPlansUpdated();
        }
    }

    return (
        <div>
            <br></br>
            <center>
                <input type='checkbox' checked={cloneTrades} onClick={() => setCloneTrades(!cloneTrades)} />Clone Trades with plan
            </center>
            <br></br>
            <Table border="1">
                <tr>
                    <th>Name</th>
                    <th>Change Name</th>
                    <th>Description</th>
                    <th>Daily Reconcile?</th>
                    <th>Merge Long & Short</th>
                    <th>Circuit Breaker</th>
                    <th>Manage</th>
                    <th>Start Date</th>
                </tr>
                {originalData.map(plan =>
                    <tr key={plan.name}>
                        <td>{plan.name}</td>
                        <td><input type="text" size="20" defaultValue={plan.name} onChange={(e) => onNameUpdated(plan.idplans, e.target.value)}></input></td>
                        <td><input type="text" size="30" defaultValue={plan.description} onChange={(e) => onDescriptionUpdated(plan.idplans, e.target.value)}></input>
                            &nbsp;{shouldAllowEdits(plan.idplans) ? <button class="btn btn-secondary" onClick={(e) => handleSubmitDescription(plan.idplans)}>Update</button> : null}
                        </td>
                        <td><input type="checkbox" checked={plan.daily_reconcile}></input></td>
                        <td><input type="checkbox" checked={plan.merge_long_short} onChange={(e) => handleUpdateHedgeStrategy(plan.idplans, !plan.merge_long_short)} ></input></td>
                        <td><>
                            &nbsp;{tableHelpers.boolFormatter(plan.trading_disabled, null)}
                            &nbsp;{shouldAllowEdits(plan.idplans) ? <TwoStepConfirmationButton id={plan.idplans} text="Trigger" backgroundColor={'white'} onConfirmed={handleCircuitBreakerTrigger} /> : null}
                        </>
                        </td>
                        <td>
                            &nbsp;<button class="btn btn-primary" onClick={() => handleClone(plan.planId)}>Clone</button>
                            {shouldAllowEdits(plan.idplans) ? <>&nbsp;&nbsp;<TwoStepConfirmationButton id={plan.planId} text="❌" backgroundColor={'white'} onConfirmed={handleDelete} /></> : null}
                            {shouldAllowEdits(plan.idplans) && plan.cloned_from_plan ? <>&nbsp;&nbsp;<TwoStepConfirmationButton id={plan.planId} text="Restore" backgroundColor={'white'} onConfirmed={handleRestoreAllocations} /></> : null}
                        </td>
                        <td>{new Date(plan.start_date).toDateString()}</td>
                    </tr>
                )}
            </Table>

            <ActionResult result={result} />
        </div >);
}

export default ManagePlans;